import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { VariantStyleIconsComponent } from './variant-style-icons.component';

@NgModule({
  declarations: [VariantStyleIconsComponent],
  imports: [CommonModule, RouterModule, UrlModule, I18nModule],
  exports: [VariantStyleIconsComponent],
})
export class VariantStyleIconsModule {}
